import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 5px 0 0 0;
`
